import React from 'react';
import ReactDOM from 'react-dom/client';
import Home from './pages/Home';

// Styles
import './styles/design-system.css';

ReactDOM.createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <Home />
    </React.StrictMode>
);
